import { connect } from "react-redux";
import { goBack } from "react-router-redux";
import Form from "../../components/forms/OneFieldForm";
import { rejectInitiative, withRedirect } from "../../CroActions";
import { breadcrumbs } from "../../../../actions/appActions";

const mapStateToProps = (state, { params }) => ({
  breadcrumbsItems: [
    { label: "Podněty k prošetření" },
    { label: "Zamítnout podnět" },
  ],
  initialValues: { id: params.id },
  submitLabel: "Zamítnout",
  title: "Důvod",
  name: "reason",
  multiline: true,
});

const onSubmit = withRedirect(rejectInitiative, "/spravce/podnety");

export default connect(mapStateToProps, { onSubmit, breadcrumbs, goBack })(
  Form,
);
